import { AddWhitelistedAddressModal as SharedAddWhitelistedAddressModal } from '@valiant/ui-shared'
import {
  useCreateWhitelistedAddressMutation,
  useGetCompanyWhitelistedAddressesQuery,
} from '@/generated/graphql'

interface AddWhitelistedAddressModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  companyId: string
}

export function AddWhitelistedAddressModal({
  open,
  onOpenChange,
  companyId,
}: AddWhitelistedAddressModalProps) {
  const [, createAddress] = useCreateWhitelistedAddressMutation()

  // Get existing addresses to check for duplicates
  const [{ data: existingAddressesData }] = useGetCompanyWhitelistedAddressesQuery({
    variables: { companyId },
    pause: !companyId,
  })

  return (
    <SharedAddWhitelistedAddressModal
      open={open}
      onOpenChange={onOpenChange}
      companyId={companyId}
      existingAddresses={existingAddressesData?.getCompanyWhitelistedAddresses || []}
      onCreateWhitelistedAddress={createAddress}
    />
  )
}
